export const config = { apiUrl: 'https://api.oxygen-demo.caple.info', appUrl: 'https://demo.eevery.co/' };
